import * as Headless from '@headlessui/react';

/**
 * "Showing N of M … Load more" footer matching the workspace list pattern.
 */
export function ConnectionLoadMoreFooter(props: {
  shown: number;
  /** Omit when no total is known -- the footer then just says how many are shown. */
  totalCount?: number;
  noun: string;
  hasNextPage: boolean;
  onLoadMore: () => void;
  loading?: boolean;
  error?: boolean;
}) {
  const {
    shown,
    totalCount,
    noun,
    hasNextPage,
    onLoadMore,
    loading = false,
    error = false
  } = props;
  if (!hasNextPage) {
    return null;
  }

  return (
    <div className="px-4 py-1.5 text-center dark:border-neutral-700">
      <span className="text-xs text-neutral-500 dark:text-neutral-400">
        {totalCount === undefined
          ? `Showing ${shown} ${noun}.`
          : `Showing ${shown} of ${totalCount} ${noun}.`}{' '}
        <Headless.Button
          type="button"
          onClick={onLoadMore}
          disabled={loading}
          aria-busy={loading}
          className="inline text-primary-600 dark:text-primary-400 hover:text-primary-800 dark:hover:text-primary-300 hover:underline font-medium disabled:text-neutral-400 dark:disabled:text-neutral-500 disabled:no-underline"
        >
          {loading ? 'Loading…' : 'Load more'}
        </Headless.Button>
        {error && (
          <span className="ml-2 text-rose-600 dark:text-rose-400">Unable to load more.</span>
        )}
      </span>
    </div>
  );
}
